import * as types from "./mutation-types";

export default {
  [types.SET_MESSAGE](state, payload) {
    state.message = payload;
  },
  [types.SET_ALERTS](state, payload) {
    state.alerts = payload;
  },
  [types.SET_PAGINATION](state, payload) {
    state.pagination = payload;
  },
  [types.SET_COUNT](state, payload) {
    state.count_alerts = payload;
  },
};
